// 定义静态路由，动态路由(后端接口返回)及处理在 `utils/routesFilter.js` 中

export default [
    {
        path: '/static/domain',
        component: () => import('views/modules/demo/domain'),
        meta: {
            title: '测试1',
        },
    },
    {
        path: '/static/domain-private',
        component: () => import('views/modules/demo/domain-private'),
        meta: {
            title: '测试2',
        },
    },
];
